import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-image-viewer',
  templateUrl: './modal-image-viewer.component.html',
  styleUrls: ['./modal-image-viewer.component.scss']
})
export class ModalImageViewerComponent implements OnInit {

  @ViewChild('imageViewerModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-lg', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  image = '';
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.modalServ.onImageViewer.subscribe(req => {
      this.image = req.image;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onImageViewerHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

}
